import React from "react";
import {
  AutocompleteInput,
  Edit,
  ReferenceInput,
  // SelectInput,
  SaveButton,
  SimpleForm,
  TextField,
  Toolbar,
} from "react-admin";
// Local
import { SettingInput } from "../../components";

const EditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const DealerSettingEdit = props => (
  <Edit mutationMode="pessimistic" {...props}>
    <SimpleForm redirect="list" toolbar={<EditToolbar />}>
      <ReferenceInput source="dealerId" reference="dealers">
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <TextField source="name" />
      <TextField source="description" />
      <SettingInput initialValue="" source="value" fullWidth />
    </SimpleForm>
  </Edit>
);

export default DealerSettingEdit;
